export default __webpack_public_path__ + "static/media/isle.49ee634d.mp4";